import React from "react";
import { Spinner, Container, Row } from "react-bootstrap";
export function SpinnerLoad({}) {
  return (
    <Container>
      <Row
        style={{
          justifyContent: "center",
        }}
      >
        <Spinner animation="grow" variant="primary" size="lg" />
        <Spinner animation="grow" variant="secondary" size="lg" />
        <Spinner animation="grow" variant="success" size="lg" />
      </Row>
    </Container>
  );
}
